var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeleteRow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.546,
    height: 24.546,
    viewBox: "0 0 24.546 24.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13212",
    "data-name": "Path 13212",
    d: "M12.273,23.012A10.739,10.739,0,1,1,23.012,12.273,10.739,10.739,0,0,1,12.273,23.012m0,1.534A12.273,12.273,0,1,0,0,12.273,12.273,12.273,0,0,0,12.273,24.546",
    fill: "#505465"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13213",
    "data-name": "Path 13213",
    d: "M4.724,4.724a.767.767,0,0,1,1.086,0L9.87,8.785l4.059-4.061a.768.768,0,0,1,1.086,1.086L10.954,9.87l4.061,4.059a.768.768,0,0,1-1.086,1.086L9.87,10.954,5.811,15.015a.768.768,0,1,1-1.086-1.086L8.785,9.87,4.724,5.811a.767.767,0,0,1,0-1.086",
    transform: "translate(2.403 2.403)",
    fill: "#505465"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteRow);
export default __webpack_public_path__ + "static/media/icon-delete-row.43312613e0f132d308665846972efc9f.svg";
export { ForwardRef as ReactComponent };